// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1OS1S","title":"Header_title__C8z0V","left":"Header_left__Rqrxo","clinicName":"Header_clinicName__26SxE"};